'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var createFormDataForAttachment = exports.createFormDataForAttachment = function createFormDataForAttachment(_ref) {
  var file = _ref.file;

  var formData = new FormData();

  formData.append('file', file);

  return formData;
};


//////////////////
// WEBPACK FOOTER
// ./js/file-uploads/util/createFormDataForAttachment.js
// module id = 559
// module chunks = 2 3